export default "__VITE_ASSET__C985pHbW__"